---
fr:
  rows:
    connection: connexion
    connections: Connexions
  suppliers:
    add_supplier: Ajouter un fournisseur
    categories:
      advisor_commercial: Conseil commercial
      advisor_legal: Conseil légal
      advisor_mna: Conseil M&A
      advisor_technical: Conseil technique
      association: Association
      consultant: Consultant
      electricity_company: Entreprise d'électricité
      entrepreneur: Entrepreneur
      equipment_supplier: Fournisseur d'équipement
      finance: Finance
      grid_owner: Gestionnaire de réseau
      insurance: Assurance
      investor: Investisseur
      journalist: Journaliste
      operation_and_maintenance: Operation & maintenance
      other: Autre
      power_trader: Trading d'électricité
      risk_management: Gestion du risque
      student: Étudiant
      telecommunication: Télécommunication
    category: Catégorie
    roles:
      control_system: Système de contrôle
      generator: Générateur
      turbine: Turbine
    supplier: Fournisseur
    supplier_created: Fournisseur créé
    supplier_role: Rôle du fournisseur
    supplier_updated: Fournisseur mis à jour
    suppliers: Fournisseurs
    url_facebook: Facebook
    url_homepage: Site Web
    url_instagram: Instagram
    url_linked_in: LinkedIn
